import React from 'react';
import PropTypes from 'prop-types';
import { Title } from '@patternfly/react-core';

export const WizardTitle = ({ title, ...props }) => (
  <Title headingLevel="h2" className="wizard-title" {...props}>
    {title}
  </Title>
);

WizardTitle.propTypes = {
  title: PropTypes.string.isRequired,
};
export default WizardTitle;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_remote_execution-8.0.0-2.fm3_4.el8.noarch/usr/share/gems/gems/foreman_remote_execution-8.0.0/webpack/JobWizard/steps/form/WizardTitle.js